export default "__VITE_ASSET__3FifwyxB__"